"use strict";

var React = require('react');

var PropTypes = require('prop-types');

function Highlight(_ref) {
  var children = _ref.children,
      color = _ref.color;
  return /*#__PURE__*/React.createElement("span", {
    style: {
      color: color
    }
  }, children);
}

Highlight.defaultProps = {
  color: 'red'
};
Highlight.propTypes = {
  color: PropTypes.string,
  children: PropTypes.any
};
module.exports = Highlight;